import React from 'react'
import {Link} from 'react-router-dom'

const ErrorNotice = () => {
  return (
    <div style={{boxSizing: 'border-box', textAlign: 'center'}}>
      <Link to="/"><i className="fa fa-refresh" aria-hidden="true"/></Link>
    </div>
  )
};

export default ErrorNotice
